import React from 'react';
import { Announcement } from 'types';
// eslint-disable-next-line import/no-extraneous-dependencies
import moment from 'moment';
import { Flex, Text, Box, Heading, Badge, Button, Icon, useColorModeValue } from '@chakra-ui/react';
import { BellIcon, ExternalLinkIcon } from '@chakra-ui/icons';
import { t, Trans } from '@lingui/macro';

interface AnnouncementCardProps {
  announcement: Announcement;
  onViewAllAnnouncements: () => void;
}

export const AnnouncementCard: React.FC<AnnouncementCardProps> = ({ announcement, onViewAllAnnouncements }) => {
  const bgColor = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.700');
  const accentColor = useColorModeValue('blue.500', 'blue.300');
  const headingColor = useColorModeValue('gray.800', 'white');
  const descriptionColor = useColorModeValue('gray.700', 'gray.300');

  return (
    <Box width="100%" height="100%" display="flex" flexDirection="column" minHeight="200px">
      <Flex justify="space-between" align="center" mb={4}>
        <Flex align="center">
          <Icon as={BellIcon} color={accentColor} mr={2} boxSize={5} />
          <Heading size="md" color={headingColor}>
            {announcement.title || 'Duyurular'}
          </Heading>
        </Flex>
        <Button
          rightIcon={<ExternalLinkIcon />}
          size="sm"
          variant="outline"
          borderColor={accentColor}
          color={accentColor}
          _hover={{ bg: useColorModeValue('blue.50', 'blue.900') }}
          onClick={onViewAllAnnouncements}
        >
          <Trans>Tüm Duyurular</Trans>
        </Button>
      </Flex>

      <Box
        p={5}
        borderWidth="1px"
        borderRadius="lg"
        borderColor={borderColor}
        bg={bgColor}
        boxShadow="sm"
        flex="1"
        position="relative"
        overflow="hidden"
        _before={{
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          width: '4px',
          height: '100%',
          bg: accentColor,
        }}
      >
        <Flex justify="space-between" mb={3}>
          <Badge colorScheme="blue" variant="subtle" px={2} py={1} borderRadius="full">
            {moment(announcement.createdAt).format('DD MMMM YYYY')}
          </Badge>
        </Flex>

        <Text
          color={descriptionColor}
          fontSize="md"
          lineHeight="tall"
          fontWeight="normal"
          opacity={announcement.description ? 1 : 0.7}
          whiteSpace="normal"
          overflowY="auto"
          maxHeight="calc(100% - 40px)"
        >
          {announcement.description || t`Şu anda aktif bir duyuru bulunmamaktadır.`}
        </Text>
      </Box>
    </Box>
  );
};
